<template>
	<div class="pe-form f-s-14 p-15">
		<div class="c-333 m-b-15">质控价格：当前项目去重后总字数{{ wordNum }}字/词（中朝或非中文单词）</div>
		<div class="d-f align-c m-b-10" v-if="editNum">
			<span class="c-333 w-145">要求完成时间：</span>
            <span v-if="taskListOption.length">{{taskListOption[0].limitTime | parseTime}}</span>
		</div>
        <div class="d-f align-c m-b-10" v-if="editNum">
			<span class="c-333 w-145">PM派发时间：</span>
            <span v-if="taskListOption.length">{{taskListOption[0].updateTime | parseTime}}</span>
		</div>
		<div class="d-f align-c m-b-5">
			<span class="c-333 w-145">子质控任务个数预设：</span>
			<section v-if="editNum">
				<el-input-number :min="1" v-model="taskNum" @input.native="handlerEditNum($event)"></el-input-number>
				<el-button class="m-l-10" type="primary" plain @click="setTaskNum">确定</el-button>
			</section>
			<span v-else>{{taskListOption.length-1 || 0}}</span>
		</div>
		<div v-if="editNum" class="c-999 f-s-12 p-l-145">请输入需要派发的子质控任务数量，系统将自动按句数拆稿，生成任务字数<span class="c-danger">（分配后不可更改个数）</span></div>
		<div v-if="!taskLoading" class="d-f align-s m-t-15">
			<span class="c-333 w-135">质控任务明细：</span>
			<el-table :data="taskListOption" :row-class-name="tableRowClassName" max-height="400" border style="width: 70%">
				<el-table-column prop="taskType" label="任务类型" width="80" type="index">
					<template slot-scope="scope">
						{{scope.row.taskType == 1 ? '主质控' : `子质控-${scope.row.index}`}}
					</template>
				</el-table-column>
				<el-table-column prop="price" label="质控单价">
					<template slot-scope="scope">
						<div v-if="!scope.row.isEdit || scope.row.index==0">
							<span class="m-r-10">{{scope.row.priceType ===1 ? '一口价' : '字数*千字单价'}}</span>
							<span>{{scope.row.priceType == 1 ? scope.row.amount : scope.row.price}}</span>
						</div>
						<div v-if="scope.row.isEdit&&scope.row.index>0" class="d-f align-c">
							<el-select class="m-r-5" @change="changePriceType(scope.row.index)" v-model="scope.row.priceType" placeholder="请选择">
								<el-option label="一口价" :value="1"></el-option>
								<el-option label="字数*千字单价" :value="2"></el-option>
							</el-select>
                            <el-tooltip content="字数由系统自动生成（按句均分）" placement="top-start" effect="dark">
								<div slot="content">建议价格：{{recommendPrice}}元/千字</div>
                                <el-input-number v-show="scope.row.priceType==1" :controls="false" @blur="checkPrice(scope.row.index)" v-model="scope.row.amount" :precision="2" :min="0" placeholder="请输入质控价格"/>
                            </el-tooltip>
                            <el-tooltip content="字数由系统自动生成（按句均分）" placement="top-start" effect="dark">
								<div slot="content">建议价格：{{recommendPrice}}元/千字</div>
								<el-input-number v-show="scope.row.priceType==2" :controls="false" @blur="checkPrice(scope.row.index)" v-model="scope.row.price" :precision="2" :min="0" placeholder="请输入质控价格"/>
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="totalPrice" label="质控价格" width="70">
					<template slot-scope="scope">
                        <span v-if="scope.row.taskType==1">{{scope.row.amount}}元</span>
                        <span v-else>
						    {{scope.row.priceType == 1 ? (scope.row.amount || 0) : (scope.row.price?(scope.row.price*scope.row.wordNum/1000).toFixed(2):0)}}元
                        </span>
                    </template>
				</el-table-column>
				<el-table-column prop="wordNum" width="110">
					<template v-slot:header>
						<el-tooltip content="字数由系统自动生成（按句均分）" placement="top-start" effect="dark">
							<span>字数（句数）</span>
						</el-tooltip>
					</template>
                    <template slot-scope="scope">
                        {{scope.row.wordNum}}字({{scope.row.sentNum}}句)
                    </template>
				</el-table-column>
				<el-table-column prop="qcList" label="质控人">
					<template slot-scope="scope">
						<div v-if="!scope.row.isEdit || scope.row.index==0" class="d-f align-c">
							<span class="m-r-10">{{scope.row.isMatch == 1 ? '手动邀请' : '自动匹配'}}</span>
							<el-tooltip placement="top-start" effect="dark">
								<div slot="content">{{scope.row.qcNameList}}</div>
								<div v-show="scope.row.status<=1&&scope.row.userWebVos.length&&scope.row.status<=1" class="qcList qcNameList p-lr-5 m-r-5">
									{{scope.row.qcNameList}}
								</div>
							</el-tooltip>
                            <el-tooltip placement="top-start" effect="dark">
								<div slot="content">{{scope.row.receiver}}</div>
								<div v-show="scope.row.status>1&&scope.row.receiver" class="qcList qcNameList p-lr-5 m-r-5">
									{{scope.row.receiver}}
								</div>
							</el-tooltip>
						</div>
						<div v-if="scope.row.isEdit&&scope.row.index>0" class="d-f align-c">
							<el-select class="w-100 m-r-10" @change="changeMatchType(scope.row.index)" v-model="scope.row.isMatch" placeholder="请选择">
								<el-option label="自动匹配" :value="2"></el-option>
								<el-option label="手动邀请" :value="1"></el-option>
							</el-select>
							<el-button v-if="!scope.row.userWebVos.length&&scope.row.isMatch==1" type="primary" plain @click.stop="showZktr(scope.row.index)">选择质控人</el-button>
							<el-tooltip placement="top-start" effect="dark">
								<div slot="content">{{scope.row.qcNameList}}</div>
								<div v-show="scope.row.status<=1&&scope.row.userWebVos.length" class="qcList p-lr-5 m-r-5">
									{{scope.row.qcNameList}}
								</div>
							</el-tooltip>
                            <el-tooltip placement="top-start" effect="dark">
								<div slot="content">{{scope.row.receiver}}</div>
								<div v-show="scope.row.status>1&&scope.row.receiver" class="qcList qcNameList p-lr-5 m-r-5">
									{{scope.row.receiver}}
								</div>
							</el-tooltip>
							<i v-if="scope.row.userWebVos.length" class="el-icon-close c-p" @click.stop="delAllZkr(scope.row.index)"/>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="60">
					<template slot-scope="scope">
						<span v-if="scope.row.status == -1">已取消</span>
						<span v-if="scope.row.status == 0">未开始</span>
						<span v-if="scope.row.status == 1">待领取</span>
						<span v-if="scope.row.status == 2">进行中</span>
						<span v-if="scope.row.status == 3">已提交</span>
					</template>
				</el-table-column>
				<el-table-column prop="limitTime" label="要求完成时间">
					<template slot-scope="scope">
						<div v-if="scope.row.limitTime">{{scope.row.limitTime | parseTime}}</div>
                        <div v-if="!scope.row.limitTime">--</div>
					</template>
				</el-table-column>
				<el-table-column prop="sendTime" label="派发时间" width="135">
					<template slot-scope="scope">
						<div v-if="scope.row.sendTime">{{scope.row.sendTime | parseTime}}</div>
                        <div v-if="!scope.row.sendTime">--</div>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="taskLoading" class="t-c p-b-20 c-999">
				<i class="el-icon-loading f-s-50"></i>
				<div class="c-999">质控任务生成中</div>
			</div>
		</div>
		<div v-if="showStartQc" class="m-t-15 p-l-135">
			<el-button type="primary" :disabled="configDisabled" @click="confirmConfig">确定开始质控</el-button>
		</div>

		<!-- 选择邀请人弹窗 -->
		<el-dialog title="选择邀请人" :visible.sync="dialogZktr" :before-close="handleClose" width="55%">
			<avue-crud :option="qcOption" :data="childQcData" :search.sync="search" @search-change="searchChange" ref="crud">
				<template slot-scope="{row,index}" slot="search">
					<section class="d-f">
						<span class="p-t-5">资源类型：</span>
						<div class="w-90">
							<el-select v-model="search.resource" clearable placeholder="请选择">
								<el-option
									v-for="item in search.options"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
						
					</section>
					<div class="el-form-item el-form-item--small l-h-32 m-l-10">
						<el-checkbox v-model="search.isProceed">未被占用<span class="f-s-12">（无进行中任务</span>）</el-checkbox>
					</div>
				</template>
				<template slot="isProceed" slot-scope="scope">
					<span v-if="scope.row.isProceed===1">是</span>
					<span v-if="scope.row.isProceed===0">否</span>
				</template>
				<template slot-scope="{row,index}" slot="menu">
					<el-button type="primary" size="mini" @click.stop="addTr(row,index)">添加</el-button>
				</template>
			</avue-crud>
		</el-dialog>


	</div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import {configQcTaskNumByQc, configQcTaskAmountByQc, updateQcTask, listQC, qcConfigInfo,} from '@/api/dot/qc';
import {recommend} from '@/api/dot/order'
import {statistics} from '@/api/dot/flow'
import {mapGetters} from "vuex";

export default {
  	props: ['configInfo', 'slan', 'tlan', 'staParams', 'wordNum'],
	data() {
		// 判断是pm还是qc
		var pmOrQc = () => {
			let type = this.$route.query.type;
			if(type == 'pm') {
				return true;
			} else if(type == 'qc') {
				return false;
			}
		};
		return {
			taskNum: 0, // 预设个数
			taskListOption: [], // 分配的任务列表
			taskLoading: false,
			currentRow: null, // 当前操作任务行
			qcNameList: '',
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now() - 8.64e7;
				},
			},
            editNum: null,
            showStartQc: null,
            currentPrice: null,
            configDisabled: false,
            currentAmount: null,


			hasLoad: false,
			loading: false,
			childConfigInfo: this.configInfo,
			recommendPrice: {},
			childConfigInfoList: [],
			pmOrQc: pmOrQc(),
			
			qcData: [],
			qcOption: {
				filterBtn: true,
				card: true,
				emptyBtn: false,
				refreshBtn: false,
				header: false, //表格头部中间菜单
				page: false,
				menu: true,
				addBtn: false, //新增按钮
				columnBtn: false,
				delBtn: false,
				editBtn: false,
				searchSpan: 7,
				searchMenuSpan: 4,
				menuWidth: 100,
				column: [
					{
						label: "质控人",
						prop: 'realname',
						search: true,
						searchLabelWidth: 60
					},
					{
						label: "是否有进行中轻任务",
						prop: "isProceed",
					},
					{
						label: "资源类型",
						prop: "userType",
					},
					{
						label: '拉黑译员人数',
						prop: 'disabledTrCount'
					}
				]
			},
			childQcData: [],
			search: {
				resource:'',
				options: [
					{
						value: '兼职',
						label: '兼职'
					}, 
					{
						value: '全职',
						label: '全职'
					}, 
					{
						value: '团队',
						label: '团队'
					}, 
					{
						value: '公司',
						label: '公司'
					}
				],
			},
			newQcList: [],
			dialogZktr: false,
			editFlag: true,
		};
	},
	watch: {
        'configInfo': function (n, o) {
			if (n.orderId) { // 待领取状态下才需要发送请求
				qcConfigInfo({orderId: n.orderId, qcOrPm: 'qc'}).then(resp => {
                    let data = resp.data.data[0];
                    this.childConfigInfo = n;
				});
			}
		},
	},
	
	computed: {
		...mapGetters(['permissions', 'userInfo', 'roles']),
        mainQcPrice() {
            if(this.taskListOption.length>1) {
                let arr = this.taskListOption.splice(0, 1);
                let newArr = arr.filter(item=>{
                    if(item.priceType == 1) {
                        return item.amount || 0
                    } else {
                        return (item.price*item.wordNum/1000).toFixed(2) || 0
                    }
                })  
                return arr.join(',')
            }
            
        }
	},
	
	mounted() {
		this.getRecommend();
		this.getConfigList();
	},
	methods: {
        // 限制数字输入框
		handlerEditNum(e) {
			e.target.value = isNaN(e.target.value) ? '' : parseInt(e.target.value);
		},

        // 校验分配价格
        checkPrice(index) {
            this.checkConfigInfo();
            let arr = this.taskListOption.filter(item=>{
                return item.taskType == 2
            })
            let amountArr = [];
            for(let i = 0; i < arr.length; i++) {
                if(arr[i].priceType == 1) {
                    if(arr[i].amount) {
                        amountArr.push(arr[i].amount)
                    } else {
                        amountArr.push(0)
                    }
                } else {
                    if(arr[i].price) {
                        amountArr.push(Number((arr[i].price*arr[i].wordNum/1000).toFixed(2)))
                    } else {
                        amountArr.push(0)
                    }
                }
            }
            const val = amountArr.reduce((preVal, curVal)=>{
                return preVal + curVal
            })
            if(val <= this.currentAmount) {
				this.editFlag = true;
                this.taskListOption[0].amount = (this.currentAmount - val).toFixed(2)
            } else {
				this.editFlag = false;
                this.$message.error('超出可分配金额');
                this.taskListOption[index].price = 0;
                this.taskListOption[index].amount = 0;
				this.checkPrice(index);
            }
        },

		tableRowClassName({ row, rowIndex }) {
			row.index = rowIndex;
		},

		// 设置预设个数--确定
		setTaskNum() {
			this.taskLoading = true;
			if(!this.pmOrQc) {
				configQcTaskNumByQc({
					num: this.taskNum,
					orderId: this.$route.query.orderId
				}).then(res=>{
					this.taskLoading= false;
					this.taskListOption = res.data.data.list.map(item=>{
						return Object.assign(item, {
							userWebVos: [],
							qcNameList: '',
							isEdit: true,
						})
					})
                    this.getBtnPermission();
                    this.getConfigList();
					console.log(this.taskListOption);
				})
			}
		},

		// 切换选择质控人方式
		changeMatchType(index) {
			this.taskListOption[index].userWebVos = [];
			this.taskListOption[index].qcNameList = '';
            this.checkConfigInfo();
		},

		// 重置当前行
		resetRow(index) {
			this.taskListOption[index].priceType = null;
			this.taskListOption[index].price = null;
			this.taskListOption[index].isMatch = null;
			this.taskListOption[index].userWebVos = [];
            this.checkConfigInfo();
		},

		// 获取建议价格
		getRecommend() {
			recommend(this.$route.query.orderId, 3).then(res => {
				this.recommendPrice = res.data.data
			})
		},

		// 选择质控人弹窗
		showZktr(index) {
			this.currentRow = index;
			listQC({
				slan: this.slan,
				tlan: this.tlan
			}).then(res => {
				this.qcData = res.data.data
				this.childQcData = this.qcData
				this.dialogZktr = true
			})
		},

		// 关闭质控人弹窗
		handleClose() {
			this.dialogZktr = false
		},

		// 质控人弹窗-搜索
		searchChange(params, done) {
			done();
			this.childQcData = this.qcData
			let temp = [];
			if (!params) {
				this.childQcData = this.qcData
			} else {
				this.childQcData.forEach(ele => {
				if (params.realname && params.realname !== ele.realname) {
					return
				}
				if (params.resource && params.resource !== ele.userType) {
					return
				}
				if (params.isProceed && ele.isProceed === 1) {
					return
				}
				temp.push(ele)
				})
			}
			this.childQcData = temp
		},

		// 添加质控人
		addTr(row, index) {
			if (this.taskListOption[this.currentRow].userWebVos == null) {
				this.taskListOption[this.currentRow].userWebVos = []
			}
			if (this.childConfigInfo.qcList == null) {
				this.childConfigInfo.qcList = []
			}
			let temp = []
			temp = temp.concat(this.taskListOption[this.currentRow].userWebVos).concat(this.childConfigInfo.qcList);
			if (!temp.find(item => item.staffId === row.staffId)) {
				this.taskListOption[this.currentRow].userWebVos.push(row)
				this.$message.success(row.realname + "，添加成功")
			} else {
				this.$message.error(row.realname + "，已添加该质控人")
			}
			let qcIds = this.taskListOption[this.currentRow].userWebVos.map(item=>{
				return item.staffId
			})
			this.taskListOption[this.currentRow].qcIds = qcIds;
			let qcNameList = this.taskListOption[this.currentRow].userWebVos.map(item=>{
				return item.realname
			})
			this.taskListOption[this.currentRow].qcNameList = qcNameList.join('/');
			this.checkConfigInfo();
		},

		// 清空质控人
		delAllZkr(index) {
			this.taskListOption[index].userWebVos = [];
			this.qcNameList = '';
            this.checkConfigInfo();
		},

		// 确认分配质控
		confirmConfig() {
			for(let i = 0; i < this.taskListOption.length; i++) {
				this.taskListOption[i].amount = this.taskListOption[i].priceType == 1 ? this.taskListOption[i].amount : (this.taskListOption[i].price*this.taskListOption[i].wordNum/1000).toFixed(2);
			}
			configQcTaskAmountByQc({
				orderId: this.$route.query.orderId,
				limitTime: this.childConfigInfo.limitTime,
				list: this.taskListOption
			}).then(res=>{
				if(res.data.data == 1) {
					this.getConfigList();
					this.childConfigInfo.status = 2;
                    this.$emit('changeVisible', false);
				}
			})
		},

		// 获取配置后的任务列表
		getConfigList() {
			qcConfigInfo({
				orderId: this.$route.query.orderId, 
				qcOrPm: ''
			}).then(res=>{
				this.taskListOption = res.data?.data.map(item=>{
					let qcNameList = item.userWebVos.map(item=>{return item.realname})
					return Object.assign(item, {
						isEdit: item.status==0 ? true : false,
						qcNameList: qcNameList.join('/')
					})
				});
				if(res.data?.data?.length == 1) {
					this.currentAmount = res.data.data[0].amount;
				} else {
					let currentAmount = res.data.data.map((item)=>{
						return item.amount
					})
					this.currentAmount = currentAmount.reduce((preVal, curVal)=>{
						return preVal + curVal
					})
				}
                this.checkConfigInfo();
			})
		},

		// 单条修改配置
		updateConfig(index) {
			this.checkPrice(index);
			if((this.taskListOption[index].isMatch==1 && !this.taskListOption[index].userWebVos.length)) {
				this.$message.error('请选择质控人');
                return;
			}
			if(this.editFlag) {
				updateQcTask({
					qcTaskId: this.taskListOption[index].id,
					amount: this.taskListOption[index].priceType == 1? (this.taskListOption[index].amount || 0) : (this.taskListOption[index].price?(this.taskListOption[index].price*this.taskListOption[index].wordNum/1000).toFixed(2):0), 
					price: this.taskListOption[index].priceType==2 ? this.taskListOption[index].price : '',
					priceType: this.taskListOption[index].priceType,
					limitTime: this.taskListOption[index].limitTime,
					qcIds: this.taskListOption[index].qcIds,
					isMatch: this.taskListOption[index].isMatch,
					operateType: 2
				}).then(res=>{
					this.getConfigList();
				})
			}
		},

        // 判断必填项
		checkConfigInfo() {
			for(let i = 0; i < this.taskListOption.length; i++) {
				console.log(this.taskListOption[i].priceType=='',(this.taskListOption[i].priceType==1 && this.taskListOption[i].amount==''),(this.taskListOption[i].priceType==2 && this.taskListOption[i].price==''),this.taskListOption[i].isMatch=='',(this.taskListOption[i].isMatch==1 && !this.taskListOption[i].userWebVos.length))
				if((this.taskListOption[i].priceType=='' || this.taskListOption[i].priceType==null) || 
					(this.taskListOption[i].priceType==1 && (this.taskListOption[i].amount==='' || this.taskListOption[i].amount===null)) || 
					(this.taskListOption[i].priceType==2 && (this.taskListOption[i].price==='' || this.taskListOption[i].price===null)) ||
					(this.taskListOption[i].isMatch=='' || this.taskListOption[i].isMatch==null) ||
					(this.taskListOption[i].isMatch==1 && !this.taskListOption[i].userWebVos.length)
				) {
					this.configDisabled = true;
				} else {
					this.configDisabled = false;
				}
			}
		},

        // 切换价格类型
		changePriceType(index) {
            this.taskListOption[index].price = 0;
            this.taskListOption[index].amount = 0;
			this.checkConfigInfo();
		},
	},
}

</script>

<style lang="scss" scoped>
.qcList {
	text-overflow: ellipsis;
    background: #b3d8ff;
    color: #FFFFFF;
    border-radius: 2px;
    max-width: 70px;
	height: 30px;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
}
.qcNameList {
	background: none;
    color: #666;
}

.input-note {
  margin: 0;
}
ul.ul-zkr {
  padding: 0;
  > li {
    width: auto;
    height: 30px;
    display: inline-block;
    list-style: none;
    line-height: 30px;
    background: #b3d8ff;
    color: #FFFFFF;
    text-align: center;
    margin-right: 5px;
    border-radius: 3px;
    > span {
      padding: 0 5px;
    }
    > .el-icon-close {
      margin-right: 3px;
      cursor: pointer;
    }
  }
}
.el-dialog__wrapper {
  :deep(.avue-group--card:last-child) {
    margin-bottom: 0 !important;
  }
}
.el-row {
  min-height: 36px;
  &:last-child {
    margin-bottom: 0;
  }
}
.common-content {
  font-size: 14px;
}
.grid-content {
  font-size: 14px;
  font-weight: bold;
  font-family: "Microsoft YaHei", sans-serif;
}
.bg-purple {
  font-size: 12px;
  color: lightgray;
}
</style>

